import { render, staticRenderFns } from "./BoxCreateForm.vue?vue&type=template&id=11a3174b&"
import script from "./BoxCreateForm.vue?vue&type=script&lang=js&"
export * from "./BoxCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports